<s1-input-label [label]="label" [inline]="true">
    <label class="switch switch-lg m-0 px-2 border border-left-0 rounded-right">
      <input type="checkbox" [formControl]="control" [attr.disabled]="readonly ? true : null" />
      <span></span>
    </label>
  </s1-input-label>